export default "__VITE_ASSET__8EluhbvV__"